import React from 'react';
import PropTypes from 'prop-types';
import { isNonEmptyString, createCustomPropType } from '../../../js/app/react/validators';

import AdvWorkflow from '../AdvWorkflow/AdvWorkflowContainer';
import AverageSpentPerMonth from './Steps/AverageSpentPerMonthContainer';

const ExpensesWorkflowView = ({ branch, workflowId }) => (
  <AdvWorkflow branch={branch} workflowId={workflowId} steps={[AverageSpentPerMonth]} />
);

ExpensesWorkflowView.propTypes = {
  branch: PropTypes.arrayOf(PropTypes.number.isRequired).isRequired,
  workflowId: createCustomPropType(isNonEmptyString).isRequired,
};

export default ExpensesWorkflowView;
